import * as React from "react";
import { FaArrowsAlt } from "react-icons/fa";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { Switch } from "../switch/Switch";
import { ScrollList, ScrollListItem } from "../../layout/scroll-list/index";
const DragHandle = SortableHandle(() => (React.createElement("div", { className: "cursor-move p-lr-2 p-tb-1" },
    React.createElement(FaArrowsAlt, null))));
const SortableItem = SortableElement((props) => (React.createElement(ScrollListItem, { className: "flex-l-r-center no-select", onClick: () => props.parent.onCheck(props.itemIndex, props.item) },
    React.createElement("div", { className: "flex-line centered" },
        React.createElement(Switch, { id: `${props.item._id}-switch-list`, checked: props.item.enabled, onChange: () => props.parent.onCheck(props.itemIndex, props.item) }),
        React.createElement("p", { className: "m-l-3" }, props.item.label)),
    React.createElement(DragHandle, null))));
const SortableItemContainer = SortableContainer((props) => {
    return (React.createElement(ScrollList, { height: props.height }, props.items.map((item, i) => (React.createElement(SortableItem, { key: `item-${i}`, index: i, item: item, itemIndex: i, parent: props })))));
});
export class SwitchListSortable extends React.Component {
    render() {
        const { height, items, onCheck, onSortEnd } = this.props;
        const itemsClean = items.map(item => {
            if (item._id === "config.distance") {
                if (this.props.units === "MILE") {
                    item.label = "Delivery Distance (mile)";
                }
                else {
                    item.label = "Delivery Distance (km)";
                }
            }
            return item;
        });
        return (React.createElement(SortableItemContainer, { helperClass: "zindex-100 bsl-2", pressDelay: 50, useDragHandle: true, height: height, items: itemsClean, units: this.props.units, onCheck: onCheck, onSortEnd: onSortEnd }));
    }
}
//# sourceMappingURL=sortable.js.map